import React from 'react';

// Blog component that can navigate to posts
const Blog = ({ onNavigateToPost }) => {
  const blogPosts = [
    {
      id: 7,
      title: "Obituary Writing Resources: Examples, Templates & Guides for Every Situation",
      slug: "obituary-writing-resources-guide",
      excerpt: "Whether you're writing an obituary for a parent, spouse, or grandparent — or just need a quick template — our comprehensive resource library has you covered with real examples and expert guidance.",
      date: "2026-03-31",
      readTime: "5 min read",
      category: "Resource Guide"
    },
    {
      id: 1,
      title: "How to Write an Obituary: A Complete Step-by-Step Guide",
      slug: "how-to-write-an-obituary-guide",
      excerpt: "Learn everything you need to know about writing a meaningful obituary. From gathering information to formatting, this comprehensive guide will help you honor your loved one's memory.",
      date: "2025-01-20",
      readTime: "8 min read",
      category: "Writing Guide"
    },
    {
      id: 2,
      title: "What to Include in an Obituary: Essential Information Checklist",
      slug: "what-to-include-in-obituary",
      excerpt: "Not sure what information belongs in an obituary? This checklist covers all the essential details, from basic facts to personal touches that make an obituary meaningful.",
      date: "2025-01-18",
      readTime: "6 min read",
      category: "Writing Guide"
    },
    {
      id: 3,
      title: "Obituary Examples: Templates for Different Situations",
      slug: "obituary-examples-templates",
      excerpt: "View real obituary examples for various situations - from traditional to modern, short to detailed. Find inspiration for writing your own meaningful tribute.",
      date: "2025-01-15",
      readTime: "10 min read",
      category: "Examples"
    },
    {
      id: 4,
      title: "How Much Do Funeral Homes Charge for Obituaries? The Real Cost Breakdown",
      slug: "funeral-home-obituary-cost",
      excerpt: "Funeral homes typically charge $200-$500 or more for obituary writing services. Discover why ObitAuthor offers the same professional quality at a fraction of the cost.",
      date: "2025-01-12",
      readTime: "5 min read",
      category: "Cost Comparison"
    },
    {
      id: 5,
      title: "Writing an Obituary for a Parent: A Compassionate Guide",
      slug: "writing-obituary-for-parent",
      excerpt: "Writing an obituary for a parent is one of the most difficult tasks. This guide offers compassionate advice and practical tips to help you through this emotional process.",
      date: "2025-01-10",
      readTime: "7 min read",
      category: "Writing Guide"
    },
    {
      id: 6,
      title: "Obituary vs. Eulogy: Understanding the Difference",
      slug: "obituary-vs-eulogy-difference",
      excerpt: "Many people confuse obituaries and eulogies. Learn the key differences between these two important tributes and when to use each one.",
      date: "2025-01-08",
      readTime: "4 min read",
      category: "Writing Guide"
    }
  ];

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-10">
          <div className="glass-card text-center mb-5">
            <h1 className="commercial-heading mb-3">ObitAuthor Blog</h1>
            <p className="commercial-subheading" style={{ fontSize: '1.1rem', color: '#000000' }}>
              Helpful guides, tips, and resources for writing meaningful obituaries
            </p>
          </div>

          <div className="row g-4">
            {blogPosts.map((post) => (
              <div key={post.id} className="col-md-6">
                <div 
                  className="glass-card h-100" 
                  style={{ cursor: 'pointer' }} 
                  onClick={() => {
                    if (onNavigateToPost) {
                      onNavigateToPost(post.slug);
                    } else {
                      window.location.href = `/blog/${post.slug}`;
                    }
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span className="badge" style={{ 
                      background: 'rgba(59, 130, 246, 0.2)', 
                      color: '#1e40af',
                      padding: '0.25rem 0.75rem',
                      borderRadius: '12px',
                      fontSize: '0.85rem'
                    }}>
                      {post.category}
                    </span>
                    <span style={{ color: '#666', fontSize: '0.85rem' }}>{post.readTime}</span>
                  </div>
                  <h3 className="mb-3" style={{ 
                    color: '#000000', 
                    fontSize: '1.5rem',
                    fontWeight: '600',
                    lineHeight: '1.3'
                  }}>
                    {post.title}
                  </h3>
                  <p style={{ 
                    color: '#000000', 
                    lineHeight: '1.7',
                    marginBottom: '1rem',
                    opacity: 0.9
                  }}>
                    {post.excerpt}
                  </p>
                  <div className="d-flex justify-content-between align-items-center">
                    <span style={{ color: '#666', fontSize: '0.9rem' }}>
                      {new Date(post.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                    </span>
                    <span style={{ color: '#1e40af', fontWeight: '600' }}>
                      Read More <i className="bi bi-arrow-right ms-1"></i>
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-5">
            <button 
              onClick={() => window.location.href = '/'}
              className="btn btn-primary btn-lg"
            >
              <i className="bi bi-house me-2"></i>
              Back to Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;

